import EmptyState from "@/components/EmptyState";
import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";

interface Props {
    children?: ReactNode;
}

const DropRegionBlock = ({ children }: Props) => {
    const { id, connectors: {connect, drag} } = useNode();

    const { isEmpty } = useEditor((_, query) => ({
        isEmpty: !query.node(id).childNodes().length,
    }));

    return (
      <div ref={dom => connect(drag(dom as any))} className={`tool__container ${isEmpty ? 'tool__container--empty' : ''}`}>
        {isEmpty ? <EmptyState/> : children}
      </div>
    )
}

DropRegionBlock.craft = {
  displayName: 'Drop Region',
  rules: {
    canDrag: () => true,
    canDrop: () => true,
  },
};


export default DropRegionBlock;
